import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { RoutingService } from '../../../../../services/routing.service';

@Component({
  selector: 'app-account-profile-tabs',
  templateUrl: './account-profile-tabs.component.html',
  standalone: false,
})
export class AccountProfileTabsComponent {
  public pageTitle$: Observable<string>;

  constructor(private routingService: RoutingService) {
    this.pageTitle$ = this.routingService.pageTitle$.asObservable();
  }
}
